function groupAndSortInclusionIcons(inclusionIcons: any[] = []) {
    const groups: Record<string, any[]> = {};

    for (const icon of inclusionIcons) {
        const groupName = icon?.inclusionGroup?.name;
        if (!groupName) continue;
        if (!groups[groupName]) groups[groupName] = [];
        groups[groupName].push(icon);
    }

    for (const name in groups) groups[name].sort((a, b) => (a?.position ?? 0) - (b?.position ?? 0));

    return Object.keys(groups)
        .map((name) => ({name, icons: groups[name]}))
        .sort((a, b) => (a.icons[0]?.position ?? 0) - (b.icons[0]?.position ?? 0));
}

export function useInclusionIcons(article: Ref<any | null>) {
    const inclusionGroups = computed(() => groupAndSortInclusionIcons(article.value?.inclusionIcons?.collection ?? []));
    return {inclusionGroups};
}
